import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'stripFundNumber',
  standalone: true,
})
export class StripFundNumberPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (!value) return '';
    return value.replace(/\s*\(#[^)]*\)$/, '').trim();
  }
}
